// extracted by mini-css-extract-plugin
module.exports = {"nameContainerBusiness":"styles_nameContainerBusiness__H6MKT","nameBusinessLabel":"styles_nameBusinessLabel__3Tbyg","nameInputBusiness":"styles_nameInputBusiness__1PQPU"};